module.exports = __webpack_public_path__ + "static/media/plus-blue.e8021e51.svg";